import dynamic from 'next/dynamic';
import Cookies from 'universal-cookie';
import { PLUGIN_NAME, COMPONENT_PREFIX, COOKIE_NAME, BLAZE_AUTH_TOKEN_CODE } from './constants';
import getAuthProvider from './utils/get-auth-provider';
import * as variants from './variants';

export default async function load(app) {
  app.events.once('load:custom:page-builder:component', addComponent => {
    addComponent({
      key: `${COMPONENT_PREFIX}registrationform`,
      component: dynamic(
        () =>
          import(
            /* webpackChunkName: "blazePbKpRegistrationForm" */ './components/RegistrationForm'
          )
      )
    });

    addComponent({
      key: `${COMPONENT_PREFIX}updateuseraccount`,
      component: dynamic(
        () =>
          import(
            /* webpackChunkName: "blazePbKpUpdateUserAccount" */ './components/UpdateUserAccount'
          )
      )
    });
  });

  app.events.on('package:core-auth-ui:logout', () => {
    const cookies = new Cookies();
    cookies.remove(COOKIE_NAME);

    // Browsers don't expose a cookie's domain attribute, so attempt removal at
    // every domain level — the call is a no-op if the cookie isn't scoped there.
    const parts = window.location.hostname.split('.');
    parts.forEach((_, i) => {
      cookies.remove(BLAZE_AUTH_TOKEN_CODE, { domain: `.${parts.slice(i + 1).join('.')}` });
    });
    cookies.remove(BLAZE_AUTH_TOKEN_CODE); // also try exact hostname (no dot prefix)
  });

  app.events.once('plugin:auth-fe:load:auth-providers', loadAuthProvider =>
    loadAuthProvider(getAuthProvider())
  );

  app.events.on('load:custom:page-builder:variant', addVariant => {
    Object.values(variants).forEach(variant => {
      const { key } = variant;
      addVariant(`${COMPONENT_PREFIX}${key}`, variant);
    });
  });

  return {
    name: PLUGIN_NAME
  };
}

load.pluginName = PLUGIN_NAME;
